// extracted by mini-css-extract-plugin
export var productCardStyle = "product-card-module--productCardStyle--1L1Wb";
export var halfCircle = "product-card-module--halfCircle--2b6lV";
export var productImageStyle = "product-card-module--productImageStyle--1xFE8";
export var productDetailsStyle = "product-card-module--productDetailsStyle--1Cw41";
export var productTitleStyle = "product-card-module--productTitleStyle--1V7Fh";
export var productVendorStyle = "product-card-module--productVendorStyle--25t30";
export var productHeadingStyle = "product-card-module--productHeadingStyle--28Hhm";
export var productPrice = "product-card-module--productPrice--3-pzV";
export var compareProductPrice = "product-card-module--compareProductPrice--yKQUC";